if (!customElements.get('cart-component')) {
  customElements.define(
    'cart-component',
    class CartComponent extends HTMLElement {
      constructor() {
        super();
        this.openCartButton = document.querySelector('[data-open-cart-drawer]');
        this.closeCartButtons = this.querySelectorAll('[data-close-cart]');
      }

      connectedCallback() {
        this.openCart();
        this.closeCart();
        document.addEventListener('switch:cart:afteradditem', (event) => this.onCartItemAdded(event));
        document.addEventListener('switch:cart:cartqtychange', (event) => this.updateCart(event));
      }

      openCart() {
        if (!this.openCartButton) return;
        this.openCartButton.addEventListener('click', () => {
          this.setAttribute('aria-hidden', 'false');
          this.lockScroll();
        });
      }

      closeCart() {
        if (this.closeCartButtons.length === 0) return;
        this.closeCartButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.setAttribute('aria-hidden', 'true');
            this.unlockScroll();
          });
        });
      }

      getSectionsToRender() {
        return [
          {
            selector: 'cart-drawer',
            el: '#cart-drawer-items',
          },
          {
            selector: 'cart-drawer',
            el: '#cart-drawer-footer',
          },
          {
            selector: 'main-cart-extend',
            el: '#main-cart-items',
          },
          {
            selector: 'cart-icon-bubble',
            el: '#cart-icon-bubble',
          },
        ];
      }

      onCartItemAdded(event) {
        this.setAttribute('aria-hidden', 'false');
        this.updateCart(event);
      }

      updateCart(event) {
        const data = event?.detail?.response || event;

        this.getSectionsToRender().forEach((section) => {
          const elToReplace = document.querySelector(`${section.el}`);
          const newSectionContainer = data.sections[section.selector];
          if (elToReplace && newSectionContainer) {
            const parser = new DOMParser().parseFromString(newSectionContainer, 'text/html');
            const newElement = parser.querySelector(`${section.el}`);
            if (newElement) {
              elToReplace.innerHTML = newElement.innerHTML;
            }
          }
        });
      }

      lockScroll() {
        const isFirefox = typeof InstallTrigger !== 'undefined';
        if (isFirefox) {
          document.body.style.overflow = 'hidden';
        } else {
          const scrollY = window.scrollY;
          document.body.dataset.scrollY = scrollY;
          document.body.style.position = 'fixed';
          document.body.style.top = `-${scrollY}px`;
          document.body.style.left = '0';
          document.body.style.right = '0';
          document.body.style.overscrollBehavior = 'none';
        }
      }

      unlockScroll() {
        const isFirefox = typeof InstallTrigger !== 'undefined';
        if (isFirefox) {
          document.body.style.overflow = 'auto';
        } else {
          const scrollY = document.body.dataset.scrollY || '0';
          document.body.removeAttribute('style');
          window.scrollTo({
            top: parseInt(scrollY, 10),
            behavior: 'instant',
          });
        }
      }
    }
  );
}
